(function ($) {
	// Mobile menu toggle functionality
	$(document).on("click", ".add-to-registry-form__btn", function (e) {
		e.preventDefault();

		if (!$("body").hasClass("logged-in")) {
			$(".js-login-popup-toggle").trigger("click");
			$('input[name="redirect_to"]').val(window.location.href);
			return;
		}

		var $this = $(this);
		var productId = $this.data("product-id");
		var modal = $(this).next(".add-to-registry-form__modal");
		var closeBtn = modal.find(".add-to-registry-form__modal__close");

		// Check if the button is already in the process of adding
		if ($this.hasClass("adding-to-registry")) {
			return;
		}

		// Add class to indicate adding process
		$this.addClass("adding-to-registry");
		closeBtn.on("click", function () {
			modal.removeClass("active");
		});

		// AJAX request to add product to registry
		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "get_product_form",
				product_id: productId,
			},
			success: function (response) {
				if (response.data) {
					modal
						.find(".add-to-registry-form__modal__body")
						.html(response.data);
					modal.addClass("active");

					var form = modal.find(
						".add-to-registry-form__modal__body form",
					);

					form.on("submit", function (e) {
						e.preventDefault();
						var params =
							form.serialize() + "&action=add_to_registry";
						$.ajax({
							url: "/wp-admin/admin-ajax.php",
							type: "POST",
							data: params,
							success: function (response) {
								if (response.success) {
									// Close modal and show success message
									modal
										.find(
											".add-to-registry-form__modal__body",
										)
										.html(response.data);
								} else {
									modal
										.find(
											".add-to-registry-form__modal__body",
										)
										.html(response.data);
								}
							},
							error: function (xhr, status, error) {
								console.error("AJAX error:", error);
							},
						});
					});
				}
			},
			error: function (xhr, status, error) {
				console.error("AJAX error:", error);
			},
			complete: function () {
				// Remove adding class after completion
				$this.removeClass("adding-to-registry");
			},
		});
	});

	//confirm-modal

	$(document).on("click", ".remove-product-from-registry", function (e) {
		e.preventDefault();
		var removeBtn = $(this);
		var productId = $(this).data("product-id");
		var confirmModal = $(".confirm-modal");
		var confirmModalBody = confirmModal.find(".confirm-modal__body");
		var okBtn = confirmModal.find(".confirm-modal__btn--yes");
		var cancelBtn = confirmModal.find(".confirm-modal__btn--no");

		confirmModal.addClass("active");
		confirmModalBody.html(`Are you sure you want to delete this gift?`);

		okBtn.off("click"); // Remove previous click handlers
		cancelBtn.off("click"); // Remove previous click handlers

		okBtn.on("click", function () {
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: {
					action: "delete_product_from_registry",
					product_id: productId,
				},
				success: function (response) {
					if (response.success) {
						removeBtn.closest("tr").remove();
					} else {
						console.error(
							"Failed to remove product:",
							response.data,
						);
					}

					confirmModal.removeClass("active");
				},
				error: function (xhr, status, error) {
					console.error("AJAX error:", error);
				},
			});
		});

		cancelBtn.on("click", function () {
			confirmModal.removeClass("active");
		});
	});
})(jQuery);
